import { useEffect } from "react";

export default function ScrollToTop({ tab }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tab]);

  return null;
}
